import { supabase } from './lib/supabase'
import './style.css'

const signinForm = document.getElementById('signin-form')
const emailInput = document.getElementById('email')
const passwordInput = document.getElementById('password')
const togglePasswordBtn = document.getElementById('toggle-password')
const eyeIcon = document.getElementById('eye-icon')
const errorMessage = document.getElementById('error-message')

// Toggle Password Visibility
togglePasswordBtn.addEventListener('click', () => {
    const isPassword = passwordInput.type === 'password'
    passwordInput.type = isPassword ? 'text' : 'password'
    
    if (isPassword) {
        // Eye Closed Icon
        eyeIcon.innerHTML = `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l18 18" />`
    } else {
        // Eye Open Icon
        eyeIcon.innerHTML = `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />`
    }
})

// Handle Form Submission
signinForm.addEventListener('submit', async (e) => {
    e.preventDefault()
    
    errorMessage.classList.add('hidden')
    
    const email = emailInput.value.trim()
    const password = passwordInput.value.trim()
    
    try {
        // 1. Check for Admin Login Credentials
        const { data: accounts, error: adminErr } = await supabase
            .from('admin_accounts')
            .select('*')
            .eq('username', email)

        let matchedAccount = null
        if (!adminErr && accounts && accounts.length > 0) {
            matchedAccount = accounts.find(a => a.password === password)
        }

        // Default Superadmin Fallback (admin / admin123)
        if (!matchedAccount && email === 'admin' && password === 'admin123') {
            matchedAccount = {
                id: 'superadmin-default',
                username: 'admin',
                display_name: 'Super Administrator',
                role: 'superadmin',
                assigned_client_ids: []
            }
        }

        if (matchedAccount) {
            const activeAdmin = {
                id: matchedAccount.id,
                username: matchedAccount.username,
                display_name: matchedAccount.display_name || matchedAccount.username,
                role: matchedAccount.role || 'subadmin',
                assigned_client_ids: Array.isArray(matchedAccount.assigned_client_ids)
                    ? matchedAccount.assigned_client_ids
                    : typeof matchedAccount.assigned_client_ids === 'string'
                        ? JSON.parse(matchedAccount.assigned_client_ids || '[]')
                        : []
            }
            localStorage.setItem('helix_admin_session', JSON.stringify(activeAdmin))
            window.location.href = '/admin/dashboard.html'
            return
        }

        // 2. Standard Client User Authentication
        const { data, error } = await supabase.auth.signInWithPassword({
            email,
            password,
        })
        
        if (error) throw error
        
        // Successful login -> Redirect to User Dashboard
        window.location.href = 'dashboard.html'
        
    } catch (error) {
        errorMessage.textContent = error.message
        errorMessage.classList.remove('hidden')
    }
})
